export default __webpack_public_path__ + "cf61259352b5abdaf73759aae8e8a819.ico";